export default __webpack_public_path__ + "static/blob12-31d38345d69240db8608b81162ceef14.svg";